import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { PublicFormPage } from '@/pages/public-form'

const searchSchemaValidation = z.object({
  verificationId: z.string().min(1),
})

export const Route = createFileRoute('/_public-forms/forms/$id')({
  validateSearch: (search) => searchSchemaValidation.parse(search),
  component: RouteComponent,
  search: {
    middlewares: [
      ({ search, next }) => {
        const result = next(search)
        const { verificationId: _, ...otherParams } = result
        return {
          verificationId: search.verificationId ?? result.verificationId,
          ...otherParams,
        }
      },
    ],
  },
})

export const SinglePublicFormsFormRoute = Route

function RouteComponent() {
  const { id } = SinglePublicFormsFormRoute.useParams()
  const { verificationId } = SinglePublicFormsFormRoute.useSearch()
  return <PublicFormPage id={id} verificationId={verificationId} />
}
